import { render, staticRenderFns } from "./Dispensation.vue?vue&type=template&id=104bcc40&scoped=true"
import script from "./Dispensation.vue?vue&type=script&lang=js"
export * from "./Dispensation.vue?vue&type=script&lang=js"
import style0 from "./Dispensation.vue?vue&type=style&index=0&id=104bcc40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104bcc40",
  null
  
)

export default component.exports